<template>
  <div>
    <div class="container-fluid">
      <b-row class="mt-4">
        <!--     <b-col>
          <h4 class="ml-3">Drivers</h4>
        </b-col> -->
      </b-row>
      <div class="pt-4">
        <TableBase
          :items="drivers.data"
          :fields="fields"
          :options="options"
          :busy="drivers.status === 'fetching' ? true : false"
        >
          <template v-slot:rightSide>
            <div>
              <!--      <b-button
                v-if="userHasPermission('drivers', 'write')"
                variant="outline-purple-yellow"
                class="align-bottom"
                @click="showModal()"
              >
                <b-icon icon="person-plus-fill" class="h4 m-1 align-bottom" />
                <span class="" />
              </b-button> -->
            </div>
          </template>
        </TableBase>
      </div>

      <b-modal
        id="detailsModal"
        ref="detailsModal"
        size="lg"
        hide-footer
        body-class="pl-0 pr-0"
        ok-disabled
        @hidden="userItem = {}"
      >
        <DriverForm
          :userItem="userItem"
          :refreshData="getData"
          :hideModal="hideModal"
        />
      </b-modal>
    </div>
  </div>
</template>
<script>
import TableBase from "@/modules/shared/table.vue";
import DriverForm from "./DriverForm.vue";

import { GET_DRIVER_LIST, POST_DRIVER } from "./actions";
import { mapState } from "vuex";

import { generalMixin } from "@/modules/mixin.js";
import { superAdminMixin } from "../mixins";
export default {
  components: { TableBase, DriverForm },
  mixins: [generalMixin, superAdminMixin],
  computed: {
    ...mapState({
      drivers: (state) => state.superAdminStore.driver.drivers,
    }),
    hasPermission() {
      return this.userHasPermission("drivers", "write");
    },
    fields() {
      return [
        { key: "firstName", label: "First name" },
        { key: "lastName", label: "Last name" },
        { key: "mobileNumber", label: "Mobile number" },
        {
          key: "actions",
          label: "Actions",
          note: false,
          details: true,
          validation: false,
          delete: this.hasPermission,
        },
      ];
    },
  },
  data() {
    return {
      options: {
        assign: false,
        rolFilter: false,
        add: false,
        fun: this.getData,
      },
      userItem: {},
    };
  },
  mounted() {
    this.$store.commit(
      "setAddFunction",
      this.userHasPermission("drivers", "write") ? this.showModal : null
    );
    this.getData();
  },
  methods: {
    getData(filter = "") {
      this.$store
        .dispatch(GET_DRIVER_LIST, { search: filter })
        .then(() => {})
        .catch(() => {});
    },
    async deleteItem(item) {
      const confirm = await this.showConfirmDeleteBox();
      if (!confirm) return;
      const payload = {
        id: item.id,
        status: 0,
      };
      this.$store
        .dispatch(POST_DRIVER, payload)
        .then(() => {
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("Driver could not be deleted", {
            title: "Error",
            variant: "warning",
          });
        });
    },
    activateItem(item) {
      const payload = {
        id: item.id,
        status: 1,
      };
      this.$store
        .dispatch(POST_DRIVER, payload)
        .then(() => {
          this.makeToast("Success", "Driver updated successfully", "success");
          this.getData();
        })
        .catch(() => {
          this.$root.$bvToast.toast("Driver could not be activated", {
            title: "Warning",
            variant: "warning",
          });
        });
    },
    showModal() {
      this.$bvModal.show("detailsModal");
    },
    editItem(item) {
      this.userItem = item;
      this.$bvModal.show("detailsModal");
    },
    changePage(page, filter = "") {
      const payload = {
        roleName: "ROLE_AGENT",
        search: filter,
        page: page,
      };
      this.$store
        .dispatch(GET_DRIVER_LIST, payload)
        .then(() => {})
        .catch(() => {
          this.$root.$bvToast.toast("error", {
            title: "Error",
            variant: "warning",
          });
        });
    },

    hideModal() {
      this.$bvModal.hide("detailsModal");
    },
  },
};
</script>
